<template>
    <div class="m-questionnaire__container">
        <Transition name="fadeOut" mode="out-in">
            <div class="m-questionnaire-questions" v-if="!submitted && currentIndex < questions.length">
                <h1 class="m-questionnaire__title t-heading-3">{{ title }}</h1>
                <Transition mode="out-in">
                    <div :key="currentIndex" class="m-questionnaire__content">
                        <span class="m-questionnaire__counter t-heading-6">{{ currentIndex + 1 }}/{{ questions.length }}</span>
                            <p class="m-questionnaire__question t-heading-5" v-if="currentQuestion">
                                {{ currentQuestion.question }}
                            </p>
                        <div class="m-questionnaire__buttons">
                            <button class="c-button" @click="nextQuestion(1)">{{ i18n.answer_yes }}</button>
                            <button class="c-button" @click="nextQuestion()">{{ i18n.answer_no }}</button>
                        </div>
                    </div>
                </Transition>
            </div>

            <div class="m-questionnaire-result" v-else-if="!submitted && currentIndex == questions.length">
                <QuizAnswer :loading="loading" :error="error" :answer="finalAnswer" @submit="submit" :i18n></QuizAnswer>
            </div>

            <div class="m-questionnaire-thanks" v-else-if="submitted">
                <img class="m-questionnaire-thanks__image" :src="image.sizes.large" :alt="image.alt">
                <div class="m-questionnaire-thanks__content">
                    <h1 class="m-questionnaire-thanks__title t-heading-3">{{ confirmation.title }}</h1>
                    <p class="t-heading-5">{{ confirmation.text }}</p>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import QuizAnswer from './components/QuizAnswer.vue';

const props = defineProps({
    title: {
        type: String,
    },
	questions: {
		type: Array,
		default: [],
	},
	url: {
		type: String,
	},
    confirmation: {
        type: Object,
        default() {
        }
    },
    answer_1: {
        type: Object,
        default: {},
    },
    answer_2: {
        type: Object,
        default: {},
    },
    answer_3: {
        type: Object,
        default: {},
    },
    image: {
        type: Array,
        default: [],
    },
    i18n: {
        type: Object,
    }
});

const currentIndex = ref(0);
const submitted = ref(false);
const currentQuestion = computed(() => props.questions[currentIndex.value]);
const totalScore = ref(0);
const email = ref('');
const error = ref('');
const finalAnswer = computed(() => {
    if (totalScore.value === 0) {
        return props.answer_1;
    }

    if (totalScore.value == props.questions.length) {
        return props.answer_3;
    }

    return props.answer_2;
})

const loading = ref(false);

function nextQuestion(score = 0) {
	totalScore.value += score;
    currentIndex.value++;
}

async function submit(emailSubmit) {
    email.value = emailSubmit;
	const formData = new FormData();
	formData.append('email', email.value);
	formData.append('score', totalScore.value);
    loading.value = true;

	try {
		const response = await fetch(props.url, {
			method: 'POST',
			body: formData,
		});
		const json = await response.json();
        
        if (json.success) {
            submitted.value = true;
        } else {
            error.value = json.data.message;
        }
        loading.value = false
	} catch (error) {
        loading.value = false
    }
}

</script>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.8s ease 0s;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.fadeOut-enter-active,
.fadeOut-leave-active {
    transition: opacity ease 0.5s;
}
.fadeOut-enter-from,
.fadeOut-leave-to {
    opacity: 0;
}
</style>